// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"5a31888f","154":"3f1d976b","283":"1dc80819","349":"5a31888f","451":"277b9709","846":"901d1bba"}[chunkId] + ".chunk.css";
};